module.exports = __webpack_public_path__ + "img/ready.c2c30787.png";